import styled from 'styled-components';
import HotelActiveSvg from '../../assets/verticals/hotel-active.svg';

const HotelActiveIcon = styled(HotelActiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4rem'};
height: ${props => props.height || '3.5rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default HotelActiveIcon;
